(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/products/components/card-list.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/products/components/card-list.js');
"use strict";


const ProductCard = svs.tickets_giftshop.products.components.ProductCard;
const {
  getCart
} = svs.tickets_giftshop.gift.giftform.cart.getters;
const CardList = _ref => {
  let {
    products = [],
    cart = [],
    isCartFull
  } = _ref;
  return products.map((p, i) => {
    const cartItem = cart.find(_ref2 => {
      let {
        product: {
          productId,
          productVariation,
          type,
          skinId
        }
      } = _ref2;
      return productId === p.productId && productVariation === p.productVariation && type === p.type && p.skinId === skinId;
    }) || {};
    const productCount = cartItem.amount || 0;
    const key = "product_".concat(p.productId, "_").concat(p.productVariation, "_").concat(p.type, "_").concat(p.skinId, "_").concat(i);
    return React.createElement(ProductCard, {
      isDisabled: isCartFull,
      key: key,
      lastUpdatedFromType: cartItem.lastUpdatedFromType,
      product: p,
      productCount: productCount,
      skinId: p.skinId
    });
  });
};
const mapState = state => {
  const {
    cart,
    isFull
  } = getCart(state);
  return {
    cart,
    isCartFull: isFull
  };
};
svs.tickets_giftshop.products.components.CardList = ReactRedux.connect(mapState)(CardList);

 })(window);